import { m } from "framer-motion";

import { Slider } from '../../../../components';
import { SLIDER } from '../../../../constants';
import { useResponsiveSliderSettings } from '../../../../hooks/useResponsiveSliderSettings';
import { SlideItem } from './filterGroupSlideItem';

export const FilterGroupSlider = ({ anchorItem, itemsList }) => {
    const { slidesPerGroup, slidesPerView } = useResponsiveSliderSettings();

    const isAnchorItemContainsProps = Boolean(Object.keys(anchorItem).length)
    const slideItemsWithAnchorElement = anchorItem && isAnchorItemContainsProps
        ? [anchorItem, ...itemsList]
        : [...itemsList]

    return (
        <div className="product-categories">
            <m.div
                className="container-fluid"
                variants={SLIDER.CONTAINER}
                initial="hidden"
                animate="show"
            >
                <Slider
                    slidesPerGroup={slidesPerGroup}
                    slidesPerView={slidesPerView}
                    SlideItem={SlideItem}
                    slideItemConfigurations={slideItemsWithAnchorElement}
                    leftArrowClassName="swiper-filters-left-arrow"
                    rightArrowClassName="swiper-filters-right-arrow"
                    isBulletsOutsideSlides
                />

            </m.div>
        </div>
    )
}